import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import MyModal from '../../../../../../Modal';
import { TrajetoSelecaoIda, TrajetoSelecaoVolum, TrajetosIda } from '../../../../../types';
import Route from './Route';

interface IChangePredefinedOptionModal {
  changePredefinedOptionModalShow: boolean;
  setChangePredefinedOptionModalShow: Dispatch<SetStateAction<boolean>>;
  currentOption: number;
  targetOption: TrajetosIda;
  changePredefinedOption: (targetOption: TrajetosIda) => Promise<void>;
  correspondingGoingRoute: TrajetoSelecaoIda[];
  correspondingReturningRoute: TrajetoSelecaoVolum[];
  canEnableActions: boolean;
}

const RoutesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  >div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h6 {
      font-size: 14px;
      font-weight: bolder;
    }
  }
`;

export default function ChangePredefinedOptionModal({
  changePredefinedOptionModalShow,
  setChangePredefinedOptionModalShow,
  currentOption,
  targetOption,
  changePredefinedOption,
  correspondingGoingRoute,
  correspondingReturningRoute,
  canEnableActions,
}: IChangePredefinedOptionModal) {
  return (
    <MyModal
      show={changePredefinedOptionModalShow}
      title="Opções de rota pré-definidas"
      centeredBody
      modalBody={(
        <>
          <h6 style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '16px' }}>
          Tem certeza que deseja alterar o resultado da opção {currentOption === 4 ? 'personalizada' : currentOption} para a opção {targetOption.trajeto}?
          </h6>

          <RoutesContainer>
            {correspondingGoingRoute.length > 0 && (
              <div>
                <h6>Ida opção {targetOption.trajeto}</h6>
                <Route route={correspondingGoingRoute} />
              </div>
            )}

            {correspondingReturningRoute.length > 0 && (
              <div>
                <h6>Volta opção {targetOption.trajeto}</h6>
                <Route route={correspondingReturningRoute} />
              </div>
            )
            }
          </RoutesContainer>
        </>
      )}
      type="action"
      closeButtonLabel="Fechar"
      actionButtonLabel="Confirmar alteração"
      onClose={() => {
        setChangePredefinedOptionModalShow(false);
      }}
      onAction={() => changePredefinedOption(targetOption)}
      isActionButtonDisabled={!canEnableActions}
    />
  );
}
